export class AutenticacaoCustom {
    static autenticacao : string;

    static setAutenticacaoCustom(autenticacao: string) {
        this.autenticacao = autenticacao;
    }    
}